export default "__VITE_ASSET__BNwzWvrS__"